import { render, staticRenderFns } from "./HomeRHProtegido.vue?vue&type=template&id=20d73e4d&scoped=true&"
import script from "./HomeRHProtegido.vue?vue&type=script&lang=js&"
export * from "./HomeRHProtegido.vue?vue&type=script&lang=js&"
import style0 from "./HomeRHProtegido.vue?vue&type=style&index=0&id=20d73e4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d73e4d",
  null
  
)

export default component.exports